// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5641) return "static/chunks/5641-ed0769b2d8731a2e.js";
	if (chunkId === 9624) return "static/chunks/9624-a6e03f99068d363a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1236":"907358e4ae3cb1de","3174":"9e963d6cf7e75b0d","9621":"8fe0e8cb78081170"}[chunkId] + ".js";
};